// Generated by purs version 0.13.8
"use strict";
var Data_Lens_Fold = require("../Data.Lens.Fold/index.js");
var Data_Lens_Getter = require("../Data.Lens.Getter/index.js");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget/index.js");
var Data_Lens_Iso_Newtype = require("../Data.Lens.Iso.Newtype/index.js");
var Data_Lens_Record = require("../Data.Lens.Record/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Maybe_First = require("../Data.Maybe.First/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Formless_Data_FormFieldResult = require("../Formless.Data.FormFieldResult/index.js");
var Formless_Types_Form = require("../Formless.Types.Form/index.js");
var Heterogeneous_Mapping = require("../Heterogeneous.Mapping/index.js");
var GetTouchedField = (function () {
    function GetTouchedField() {

    };
    GetTouchedField.value = new GetTouchedField();
    return GetTouchedField;
})();
var GetResultField = (function () {
    function GetResultField() {

    };
    GetResultField.value = new GetResultField();
    return GetResultField;
})();
var GetOutput = (function () {
    function GetOutput() {

    };
    GetOutput.value = new GetOutput();
    return GetOutput;
})();
var GetInputField = (function () {
    function GetInputField() {

    };
    GetInputField.value = new GetInputField();
    return GetInputField;
})();
var GetError = (function () {
    function GetError() {

    };
    GetError.value = new GetError();
    return GetError;
})();
var getTouchedField = new Heterogeneous_Mapping.Mapping(function (v) {
    return function (v1) {
        return v1.touched;
    };
});
var getTouchedAll = function (dictHMap) {
    return function (dictNewtype) {
        var $79 = Heterogeneous_Mapping.hmap(dictHMap)(GetTouchedField.value);
        var $80 = Data_Newtype.unwrap(dictNewtype);
        return function ($81) {
            return $79($80($81));
        };
    };
};
var getResultField = new Heterogeneous_Mapping.Mapping(function (v) {
    return function (v1) {
        return v1.result;
    };
});
var getResultAll = function (dictHMap) {
    return function (dictNewtype) {
        var $82 = Heterogeneous_Mapping.hmap(dictHMap)(GetResultField.value);
        var $83 = Data_Newtype.unwrap(dictNewtype);
        return function ($84) {
            return $82($83($84));
        };
    };
};
var getOutputAll = function (dictHMap) {
    return function (dictNewtype) {
        var $85 = Heterogeneous_Mapping.hmap(dictHMap)(GetOutput.value);
        var $86 = Data_Newtype.unwrap(dictNewtype);
        return function ($87) {
            return $85($86($87));
        };
    };
};
var getOutput$prime = new Heterogeneous_Mapping.Mapping(function (v) {
    return function (v1) {
        return Formless_Data_FormFieldResult.toMaybe(v1.result);
    };
});
var getInputField = new Heterogeneous_Mapping.Mapping(function (v) {
    return function (v1) {
        return v1.input;
    };
});
var getInputAll = function (dictHMap) {
    return function (dictNewtype) {
        var $88 = Heterogeneous_Mapping.hmap(dictHMap)(GetInputField.value);
        var $89 = Data_Newtype.unwrap(dictNewtype);
        return function ($90) {
            return $88($89($90));
        };
    };
};
var getErrorResult$prime = new Heterogeneous_Mapping.Mapping(function (v) {
    return function (v1) {
        if (v1.result instanceof Formless_Data_FormFieldResult["Error"]) {
            return new Data_Maybe.Just(v1.result.value0);
        };
        return Data_Maybe.Nothing.value;
    };
});
var getErrorAll = function (dictHMap) {
    return function (dictNewtype) {
        var $91 = Heterogeneous_Mapping.hmap(dictHMap)(GetError.value);
        var $92 = Data_Newtype.unwrap(dictNewtype);
        return function ($93) {
            return $91($92($93));
        };
    };
};
var _Field = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return function (dictStrong) {
                    var $94 = Data_Lens_Iso_Newtype["_Newtype"](dictNewtype)(dictNewtype)(dictStrong.Profunctor0());
                    var $95 = Data_Lens_Record.prop(dictIsSymbol)()()(sym)(dictStrong);
                    var $96 = Data_Lens_Iso_Newtype["_Newtype"](Formless_Types_Form.newtypeFormField)(Formless_Types_Form.newtypeFormField)(dictStrong.Profunctor0());
                    return function ($97) {
                        return $94($95($96($97)));
                    };
                };
            };
        };
    };
};
var _FieldInput = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return function (dictStrong) {
                    var $98 = _Field(dictIsSymbol)(dictNewtype)()(sym)(dictStrong);
                    var $99 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
                        return "input";
                    }))()()(Data_Symbol.SProxy.value)(dictStrong);
                    return function ($100) {
                        return $98($99($100));
                    };
                };
            };
        };
    };
};
var getInput = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return Data_Lens_Getter.view(_FieldInput(dictIsSymbol)(dictNewtype)()(sym)(Data_Lens_Internal_Forget.strongForget));
            };
        };
    };
};
var _FieldResult = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return function (dictStrong) {
                    var $101 = _Field(dictIsSymbol)(dictNewtype)()(sym)(dictStrong);
                    var $102 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
                        return "result";
                    }))()()(Data_Symbol.SProxy.value)(dictStrong);
                    return function ($103) {
                        return $101($102($103));
                    };
                };
            };
        };
    };
};
var _FieldError = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return function (dictWander) {
                    var $104 = _FieldResult(dictIsSymbol)(dictNewtype)()(sym)(dictWander.Strong0());
                    var $105 = Formless_Data_FormFieldResult["_Error"](dictWander.Choice1());
                    return function ($106) {
                        return $104($105($106));
                    };
                };
            };
        };
    };
};
var getError = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return Data_Lens_Fold.preview(_FieldError(dictIsSymbol)(dictNewtype)()(sym)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)));
            };
        };
    };
};
var _FieldOutput = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return function (dictWander) {
                    var $107 = _FieldResult(dictIsSymbol)(dictNewtype)()(sym)(dictWander.Strong0());
                    var $108 = Formless_Data_FormFieldResult["_Success"](dictWander.Choice1());
                    return function ($109) {
                        return $107($108($109));
                    };
                };
            };
        };
    };
};
var getOutput = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return Data_Lens_Fold.preview(_FieldOutput(dictIsSymbol)(dictNewtype)()(sym)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)));
            };
        };
    };
};
var getResult = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return Data_Lens_Getter.view(_FieldResult(dictIsSymbol)(dictNewtype)()(sym)(Data_Lens_Internal_Forget.strongForget));
            };
        };
    };
};
var _FieldTouched = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return function (dictStrong) {
                    var $110 = _Field(dictIsSymbol)(dictNewtype)()(sym)(dictStrong);
                    var $111 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
                        return "touched";
                    }))()()(Data_Symbol.SProxy.value)(dictStrong);
                    return function ($112) {
                        return $110($111($112));
                    };
                };
            };
        };
    };
};
var getTouched = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return Data_Lens_Getter.view(_FieldTouched(dictIsSymbol)(dictNewtype)()(sym)(Data_Lens_Internal_Forget.strongForget));
            };
        };
    };
};
var getField = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictCons) {
            return function (sym) {
                return Data_Lens_Getter.view(_Field(dictIsSymbol)(dictNewtype)()(sym)(Data_Lens_Internal_Forget.strongForget));
            };
        };
    };
};
module.exports = {
    getField: getField,
    getInput: getInput,
    getTouched: getTouched,
    getResult: getResult,
    getError: getError,
    getOutput: getOutput,
    getInputAll: getInputAll,
    getTouchedAll: getTouchedAll,
    getResultAll: getResultAll,
    getErrorAll: getErrorAll,
    getOutputAll: getOutputAll,
    "_Field": _Field,
    "_FieldInput": _FieldInput,
    "_FieldTouched": _FieldTouched,
    "_FieldResult": _FieldResult,
    "_FieldError": _FieldError,
    "_FieldOutput": _FieldOutput,
    GetInputField: GetInputField,
    GetTouchedField: GetTouchedField,
    GetResultField: GetResultField,
    GetError: GetError,
    GetOutput: GetOutput,
    getInputField: getInputField,
    getTouchedField: getTouchedField,
    getResultField: getResultField,
    "getErrorResult'": getErrorResult$prime,
    "getOutput'": getOutput$prime
};
